import {
  breakpointSizes,
  getBreakpointOnly,
  styleConstants,
} from '@paywithextend/components'
import React from 'react'
import { css } from 'styled-components'

interface IntegrationPopupFooterProps {
  className?: string
}

const IntegrationPopupFooter: React.FC<
  React.PropsWithChildren<IntegrationPopupFooterProps>
> = (props): React.ReactElement => {
  return (
    <div
      className={props.className}
      css={css`
        background-color: ${styleConstants.colors.gray_light};
        padding: ${styleConstants.heights.popupPaddingXSMUp};
        border-bottom-right-radius: ${styleConstants.borderRadius.box};
        border-bottom-left-radius: ${styleConstants.borderRadius.box};
        ${getBreakpointOnly(breakpointSizes.XXSM)(css`
          padding: ${styleConstants.heights.popupPaddingXXSMOnly};
        `)}
      `}
    >
      {props.children}
    </div>
  )
}

export default IntegrationPopupFooter
